module.exports = __webpack_public_path__ + "TuGo-Logo.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./app/images/TuGo-Logo.jpg
// module id = ./node_modules/file-loader/index.js?name=[name].[ext]!./app/images/TuGo-Logo.jpg
// module chunks = 15